<template>
  <div class="root">
    <div class="invoice-main" ref="layout">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    $route (to, from) {
      if (to.meta.keepAlive && to.path !== from.path) {
        this.$router.go(0)
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
